import React from 'react';
import AppBar from 'material-ui/AppBar';

const Header = (props) => (
  <AppBar
    {...props}
    title="Go Ayutthaya"
    iconClassNameRight="muidocs-icon-navigation-expand-more"
  />
);

export default Header



// WEBPACK FOOTER //
// ./src/template/Header.js